import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const VerifiySml = (props: SvgIconT.Props) => (
  <SvgIcon width={13} height={13} {...props} viewBox="0 0 13 13">
    <g>
      <path
        fill="#d4ece3"
        fillRule="evenodd"
        d="M6.5,13s4.5-.8947368,5.5-4c.6632308-2.0595061,1-6.9474,1-6.9474L6.5,0,0,2s.1558487,5.007803,1,7c1.3157895,3.1052632,5.5,4,5.5,4Z"
      />
      <path
        fill="#237e57"
        d="M6.4970884.7855905l5.7089357,1.8027941c-.1114159,1.3438051-.4244509,4.6431489-.9199238,6.181715-.7560968,2.3478746-4.0305347,3.2756624-4.7796512,3.4590874-.7204561-.1901178-3.8026984-1.130682-4.8158892-3.5217972-.571254-1.348175-.8342799-4.5073767-.9171651-6.1606629L6.4970884.7855905M6.5,0L0,2s.15585,5.0078001,1,7c1.3157899,3.1052599,5.5,4,5.5,4,0,0,4.5-.8947401,5.5-4,.6632299-2.0595102,1-6.9474001,1-6.9474001L6.5,0h0Z"
      />
    </g>
    <path
      fill="#237e57"
      d="M6,9.625c-.1645508,0-.3242188-.0654297-.4418945-.1826172l-2-2c-.2441406-.2441406-.2441406-.6401367,0-.8842773s.6396484-.2441406.8837891,0l1.434082,1.434082,2.5878906-4.3139648c.1777344-.2954102.5615234-.390625.8574219-.2143555.2958984.1777344.3925781.5615234.2148438.8579102l-3,4.9995117c-.0991211.1650391-.2685547.2753906-.4599609.2988281-.0253906.0029297-.0507812.0048828-.0761719.0048828Z"
    />
  </SvgIcon>
);

export default VerifiySml;
